<template>
  <div>
    <LlQuizQuestionEdit
      v-for="(ques, queslist_k) in quesList"
      :key="'quesList'+queslist_k"
      v-model="ques.score"
      :btnList="btnList"
      :index="ques.index"
      :title="ques.title"
      :textareaTitle="textareaTitle"
      :attachesRules="attachesRules"
      :textareaRules="textareaRules"
      :uploadAttaches="ques.attaches"
      :popupBtnText="ques.popupBtnText"
      :popupContent="ques.popupContent"
      :hasPopupContent="hasPopupContent"
      :avatarDropdown="ques.avatarDropdown"
      :textareaContent="ques.textareaContent"
      :textareaPlaceholder="textareaPlaceholder"
      :riskListBySubClasses="ques.listBySystemSubclass"
      :updateVersionLabel="$t('風險評估項目已更新版本，請再次評估。')"
      :popupTitle="ques.popupTitle ? ques.popupTitle : ques.title"
      :updateVersion="ques.updateVersion?ques.updateVersion:false"
      :uploadModule="uploadModule"
      @update-attach="$emit('update-attach', {value: $event, index: queslist_k})"
      @reset-textarea="resetTextArea($event,queslist_k)"
      @change-textarea-vlue="$_changeTextareaValue($event,ques)"
      @click-avatar="$_onClickAvatar($event, ques)"
      @open-popup="$emit('open-popup', ques)"
    >
      <template v-slot:popup>
        <slot name="popup" :index="queslist_k"/>
      </template>
    </LlQuizQuestionEdit>
    <div v-if="addNewQuestion">
      <div
        v-for="(ques, queslistadd_k) in quesListAdd"
        :key="'quesListAdd'+ queslistadd_k"
      >
        <EditableChecklistQuestion
          :ref="`EditableChecklistQuestion_${queslistadd_k}`"
          v-model="quesListAdd[queslistadd_k]"
          class="mt-20"
          editable
          non-copy-btn
          non-file-upload
          hide-toggle-focus
          :title-area-title="$t('變因')"
          :text-label="$t('敘述')"
          :textarea-placeholder="textareaPlaceholder"
          @delete="$_deleteQuesPopupOpen(quesListAdd,queslistadd_k)"
        >
          <div class="input-item">
            <LvDropdownMultiSystemClasses
              v-model="quesListAdd[queslistadd_k].multiSystemClasses"
              class="mt-20"
              required
              title="領域"
              rules="required"
              placeholder="選擇"
              :select-value="quesListAdd[queslistadd_k].multiSystemClassesSelectValue"
              :props-menu-items="multiSystemClassMenu"
              @init-value="$_onInitMultiSystemClasses($event, queslistadd_k)"
            />
          </div>
          <div class="input-item">
            <p class="input-title">
              {{ $t('評估項目') }}<span>*</span>
            </p>
            <div class="input">
              <WsInputTextareaButton001
                v-model="quesListAdd[queslistadd_k].riskCountersign"
                :min-height="134"
                :max-height="300"
                :placeholder="$t('輸入')"
                rules="required"
              />
            </div>
          </div>
        </EditableChecklistQuestion>
      </div>
      <WsButton001
        class="mt-20"
        @click="$_addQuestionClick()"
      >
        {{ $t('新增自訂變因') }}
      </WsButton001>
    </div>
    <PopUp
      :pop-up-active="deleteQuesPopupActive"
      :title="$t('確定刪除嗎？')"
      @click="$_deleteQuesPopupClose()"
    >
      <LlCancelPopupContent>
        <template v-slot:buttons>
          <WsButton001
            out-line
            @click="$_deleteQuesPopupClose()"
          >
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_deleteQuestion(deleteQuesList, deleteQuesIndex)">
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
  </div>
</template>
<script>
export default {
  name: "LlQuizQuestionEditList",
  props: {
    textareaPlaceholder: {
      type: String,
      default() {
        return this.$t("輸入");
      },
    },
    attachesRules: {
      type: String,
      default: "",
    },
    textareaRules: {
      type: String,
      default: "",
    },
    textareaTitle: {
      type: String,
      default: "",
    },
    uploadAttaches: {
      type: Array,
      default() {
        return [];
      },
    },
    hasPopupContent: {
      type: Boolean,
      default: false,
    },
    addNewQuestion: {
      type: Boolean,
      default: false,
    },
    multiSystemClassMenu: {
      type: Array,
      default() {
        return [];
      },
    },
    btnList: {
      type: Array,
      default() {
        return [];
      },
    },
    quesList: {
      type: Array,
      default() {
        return [];
      },
    },
    quesListAdd: {
      type: Array,
      default() {
        return [];
      },
    },
    uploadModule: {
      type: String,
    }
  },
  data: () => ({
    modelmodel: null,
    deleteQuesPopupActive: false,
    deleteQuesList: [],
    deleteQuesIndex: 0,
  }),
  methods: {
    resetTextArea($event, ques_k) {
      const data = {};
      data.index = ques_k;
      data.score = $event;
      this.$emit("reset-textarea", data);
    },
    $_addQuestionClick() {
      this.$emit("add-click");
    },
    $_deleteQuesPopupOpen(questionList, index) {
      this.deleteQuesPopupActive = true;
      this.deleteQuesList = questionList;
      this.deleteQuesIndex = index;
    },
    $_deleteQuesPopupClose() {
      this.deleteQuesPopupActive = false;
      this.deleteQuesList = [];
      this.deleteQuesIndex = 0;
    },
    $_deleteQuestion(questionList, index) {
      questionList.splice(index, 1);
      this.$emit("delete-click", questionList);
      this.$_deleteQuesPopupClose();
    },
    $_changeTextareaValue(e, ques) {
      ques.textareaContent = e;
      this.$emit("change-textarea-vlue", e);
    },
    $_onClickAvatar($event, ques) {
      this.$emit('click-avatar', { id: ques.id, $event });
    },
    $_onInitMultiSystemClasses(value, index) {
      this.quesListAdd[index].multiSystemClasses = value;
    },
  },
};
</script>